module.exports = __webpack_public_path__ + "img/2.3376b386.png";